import { SDKStorage } from "./base";
export class LocalStorage extends SDKStorage {
    removeAllValues() {
        if (localStorage.length) {
            localStorage.clear();
        }
    }
    removeValue(key) {
        localStorage.removeItem(key);
    }
    getValue(key) {
        return localStorage.getItem(key);
    }
    setValue(key, value) {
        localStorage.setItem(key, value);
    }
}
//# sourceMappingURL=local-storage.js.map